import { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { pages } from 'navigation/pages'
import Invoice from '../components/Invoice'

export default function InvoiceRouter(): ReactElement {
  return <Route path={pages.connected.invoice.root.name} element={<Invoice />} />
}
